// MpfHint.props.ts

export type MpfHintTag = 'div' | 'p' | 'span';

export interface MpfHintProps {
  id?: string;
  hint: string;
  srHint?: string;
  as?: MpfHintTag;
  className?: string;
}

export const mpfHintDefaults = {
  as: 'div' as MpfHintTag,
  className: '',
} satisfies Partial<MpfHintProps>;
